import uuid from 'react-uuid';
import { encryptPayload } from './util';

const verifyClicCase = async (params) => {
  const {
    dataObj, journeyId, iformIntegrationUrls, pageType, searchUrlType, cuid,
  } = params;

  const clicPayload = {
    head: {
      traceId: uuid(),
      span: 'span',
      journeyId,
    },
    body: {
      ...dataObj,
    },
  };

  const requestOptions = {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: encryptPayload(clicPayload),
  };
  let finalResponse = {};
  const res = await fetch(`${iformIntegrationUrls}/iForms/${pageType}/oneclic/${searchUrlType}/request?cuid=${cuid}`, requestOptions);
  if (res.ok) {
    const data = await res.json();
    finalResponse = { ...data };
  } else {
    finalResponse = {
      statusIndicator: 'F',
      statusCode: res.status,
      message: res.statusText,
    };
  }
  return finalResponse;
};

/* eslint complexity: ["error", 30] -- need to increase complexity */
export const handleClicApiCall = async ({
  formContainer, formSubmissionPayload, selectedMemberInfo,
  setFormSubmissionPayload, iformIntegrationUrls, contextVal,
  handleContinue, searchUrlType, journeyId, loggerApiCall, setDynamicClicDetails,
  setIsFormSubmission,
}) => {
  setIsFormSubmission(true); // disable the button once the api is called
  // By default all the calls are static. Means the page display is static.
  const clicBody = formContainer.operations && formContainer.operations.onClic
    ? formContainer.operations.onClic
    : {
      searchType: 'static',
    };
  let clicCaseVerifyOperations = null;

  if (formContainer.operations
    && formContainer.operations.clickCaseVerify) {
    clicCaseVerifyOperations = formContainer.operations.clickCaseVerify;
  }

  /* eslint-disable no-extra-parens -- need */
  let dataObj = {
    caseNumber: formSubmissionPayload.caseNumber,
    referenceIdentifier: formSubmissionPayload.cardNumber,
    ...clicBody,
    startFrom: clicCaseVerifyOperations && clicCaseVerifyOperations.partOfCard
      ? clicCaseVerifyOperations.partOfCard : 0,
    /**
     * pass number of digits mentioned in JSON
     * if not mentioned --> if secure form then pass 15
     * otherwise pass the lenth of referenceIdentifier
     */
    numberOfDigits: clicCaseVerifyOperations && clicCaseVerifyOperations.cardNumberLength
      ? Math.abs(clicCaseVerifyOperations.cardNumberLength)
      : (selectedMemberInfo && selectedMemberInfo.accountToken
        ? 15 : formSubmissionPayload.cardNumber.length),
    isSubsetReq: clicCaseVerifyOperations && clicCaseVerifyOperations.isSubsetReq
      ? clicCaseVerifyOperations.isSubsetReq : false,
  };
  /* eslint-enable no-extra-parens -- need */

  /**
   * if it's a secure form --> we have to pass accountToken to get correct account number in backend
   * secure forms won't be validated against the referenceIdentifier passed from UI
   */
  dataObj = selectedMemberInfo && selectedMemberInfo.accountToken ? {
    ...dataObj,
    accountToken: selectedMemberInfo.accountToken,
  } : { ...dataObj };

  let logString = 'status=calledClicSearchApi';
  loggerApiCall(logString, 'info');
  const data = await verifyClicCase({
    dataObj,
    journeyId,
    iformIntegrationUrls,
    pageType: formContainer.pageType,
    searchUrlType,
    cuid: contextVal.cuid,
  });
  setIsFormSubmission(false); // enable the button once the call is successfull
  if (data.statusIndicator === 'T') {
    logString = 'status=ClicSearchApiCallSuccess';
    loggerApiCall(logString, 'info');
    const { caseStatusText } = data;
    let caseStatusToLookFor = ['CS-0000', 'Open', 'Pending-FurtherInformation', 'Re-Open', 'Pending-AwaitingDocuments'];// default case list
    let clicCaseStatusToMoveToErrorPage = null;
    let statusErrorPage = null;
    let clicWorkBasketToLookFor;

    if (clicCaseVerifyOperations) {
      if (clicCaseVerifyOperations.clicCaseStatusToLookFor) {
        caseStatusToLookFor = clicCaseVerifyOperations.clicCaseStatusToLookFor;
      }
      if (clicCaseVerifyOperations.clicCaseStatusToMoveToErrorPage) {
        clicCaseStatusToMoveToErrorPage = clicCaseVerifyOperations.clicCaseStatusToMoveToErrorPage;
      }
      if (clicCaseVerifyOperations.clicWorkBasketToLookFor) {
        clicWorkBasketToLookFor = clicCaseVerifyOperations.clicWorkBasketToLookFor;
      }
    }

    if (clicWorkBasketToLookFor && clicWorkBasketToLookFor.indexOf(data.assignedTo) === -1) {
      // validate the clic case is valid access to this jounrey
      loggerApiCall(`${logString} errorMsg=case is assigned to ${data.assignedTo}`, 'error');
      setFormSubmissionPayload({
        ...formSubmissionPayload,
        ...{
          elemId: null, wbMatchStatus: 0, cardMatchStatus: 1, cardNameVerify: 1,
        },
      });
    } else if (!(caseStatusToLookFor.indexOf(caseStatusText) >= 0)) {
      if (clicCaseStatusToMoveToErrorPage) {
        /* eslint-disable no-restricted-syntax -- need */
        for (const statusErrorCase of clicCaseStatusToMoveToErrorPage) {
          if (statusErrorCase.status.indexOf(caseStatusText) >= 0) {
            statusErrorPage = statusErrorCase.errorPage;
            break;
          }
        }
        /* eslint-enable no-restricted-syntax -- need */
      }
      if (statusErrorPage) {
        handleContinue(statusErrorPage);
      } else {
        setFormSubmissionPayload({
          ...formSubmissionPayload,
          ...{ elemId: null, caseStatusMatch: 0 },
        });
      }
    } else {
      /* eslint-disable no-lonely-if -- need */
      if (clicBody.searchType === 'static') {
        handleContinue();
      } else {
      /* eslint-enable no-lonely-if -- need */
      /* dynamic clic logic */
        const { lastPendNote } = data;
        if (lastPendNote) {
          setDynamicClicDetails(lastPendNote);
          setFormSubmissionPayload({
            ...formSubmissionPayload,
            ...{
              elemId: 'continue',
              dynamicClicDetails: lastPendNote,
            },
          });
        } else {
          setFormSubmissionPayload({
            ...formSubmissionPayload,
            ...{ elemId: null, dataToDisplay: 0 },
          });
        }
      }
    }
  } else {
    loggerApiCall(`status=ClicSearchApiCallFailed errorMsg=${data.message} status=${data.statusCode}`, 'error');
    setFormSubmissionPayload({
      ...formSubmissionPayload,
      ...{ elemId: null, cardMatchStatus: 0, cardNameVerify: 0 },
    });
  }
};
